import { NgModule } from '@angular/core';
import { KnBrQuoteModule } from './kn-br-quote/kn-br-quote.module';
import { CommonModule } from '@angular/common';
@NgModule({
  imports: [CommonModule, KnBrQuoteModule],
  providers: [],
})
export class KnBrQuoteComponentsModule {}
